import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { LimitRule, LimitType, RuleMessage } from '@lib/core/models/insurance-package.interface';

@Component({
  selector: 'hm-prescription-limits-modal',
  imports: [MatDialogClose, MatIcon, NgTemplateOutlet],
  templateUrl: './prescription-limits-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionLimitsModalComponent {
  private readonly data: {
    limits: LimitRule[];
  } = inject(MAT_DIALOG_DATA);

  protected readonly limitType = LimitType;

  protected readonly limits = signal<LimitRule[]>(this.data.limits);

  protected setRuleMessage(limit: LimitRule): string {
    return RuleMessage[limit.limitRuleName];
  }
}
